import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
  useEffect,
} from 'react';
import clone from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';

interface ILocalization {
  datePickerGridHeaderMonText: string;
  datePickerGridHeaderTueText: string;
  datePickerGridHeaderWedText: string;
  datePickerGridHeaderThuText: string;
  datePickerGridHeaderFriText: string;
  datePickerGridHeaderSatText: string;
  datePickerGridHeaderSunText: string;
  phoneInputPlaceholder: string;
}

const DEFAULT_LOCALIZATION: ILocalization = {
  datePickerGridHeaderMonText: 'MON',
  datePickerGridHeaderTueText: 'TUE',
  datePickerGridHeaderWedText: 'WED',
  datePickerGridHeaderThuText: 'THU',
  datePickerGridHeaderFriText: 'FRI',
  datePickerGridHeaderSatText: 'SAT',
  datePickerGridHeaderSunText: 'SUN',
  phoneInputPlaceholder: 'Enter phone number...',
};

const LocalizationContext = createContext<ILocalization>(clone(DEFAULT_LOCALIZATION));

export const useLocalizationContext = () => {
  const context = useContext(LocalizationContext);
  if (!context) {
    throw new Error('useLocalizationContext must be used within a LocalizationContextProvider');
  }
  return context;
};

interface ILocalizationContextProviderProps {
  value?: ILocalization;
}

export const LocalizationContextProvider = ({
  value = DEFAULT_LOCALIZATION,
  children,
}: PropsWithChildren<ILocalizationContextProviderProps>) => {
  const [localization, setLocalization] = useState<ILocalization>(value);

  useEffect(() => {
    if (!isEqual(localization, value)) {
      setLocalization(value);
    }
  }, [value]);

  return (
    <LocalizationContext.Provider value={localization}>
      {children}
    </LocalizationContext.Provider>
  );
};
